import { IPaylinkDetail } from '@paylink/types';

export class DataShareService {
	private static _paylinkDetail: IPaylinkDetail;
	private static _browserFPR: string = '';

	/**
	 * Getter and Setter for Payment Page Details
	 * Stores the complete configuration of the payment page
	 */
	static set paylinkDetail(data: IPaylinkDetail) {
		DataShareService._paylinkDetail = data;
	}

	static get paylinkDetail(): IPaylinkDetail {
		return DataShareService._paylinkDetail;
	}

	/**
	 * Getter and Setter for browserFPR
	 */
	static set browserFPR(val: string) {
		DataShareService._browserFPR = val;
	}

	static get browserFPR(): string {
		return DataShareService._browserFPR;
	}
}
